import { ToastContainer, toast } from "react-toastify";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { getAdminAuthToken } from "../../../../auth/auth";
import { API_BASE_URL, base_url, profileImgSrc } from "../../../../config";
import Loader from "../../../../components/Loader";

const statusOptions = [
  { label: "Approved", value: "2", color: "#28DDCF" },
  { label: "Pending", value: "1", color: "#FFD500" },
  { label: "Deny", value: "3", color: "#FF6633" },
];

export default function CompaniesPage() {
  const [isLoadingStatus, setIsLoadingStatus] = useState(false);
  const [openCompanyId, setOpenCompanyId] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [companies, setCompanies] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });

  const token = getAdminAuthToken();

  const fetchCompanies = async (
    filterText = "",
    statusFilter = "",
    page = 1
  ) => {
    setIsLoading(true);

    const queryParams = new URLSearchParams();
    if (filterText.trim()) queryParams.append("company", filterText);
    if (statusFilter.trim()) queryParams.append("status", statusFilter);
    queryParams.append("page", page);

    const response = await fetch(
      `${API_BASE_URL}/admin/companies?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();

    if (result.success) {
      setCompanies(result.data);
      setPagination(result.meta);
      setIsLoading(false);
    } else {
      setCompanies([]);
      return { error: result.message || "Failed to fetch companies" };
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchCompanies(filterText, statusFilter, page);
    }, 500);

    return () => clearTimeout(delay);
  }, [filterText, statusFilter]);

  const handleStatus = async (val, id) => {
    setIsLoadingStatus(true);
    const companyStatus = +val;
    const data = {
      company_id: id,
      status: companyStatus,
    };

    const response = await fetch(
      `${API_BASE_URL}/admin/companies/update-status`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    const result = await response.json();
    if (result.success === false) {
      setIsLoadingStatus(false);
      return { error: result.message || "Failed to change status." };
    }

    setCompanies((prev) =>
      prev.map((curr) => (curr.id === id ? { ...curr, status: val } : curr))
    );
    toast.success("Company status updated!");
    setOpenCompanyId(null);
    setIsLoadingStatus(false);
  };

  const handleOpen = (id) => {
    setOpenCompanyId((prev) => (prev === id ? null : id));
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="comapnies-wrapper-dashboard-page page-wrapper-dashboard-all">
        <h2>Companies</h2>
        <div className="select-candidate-filters-wrapper dash-filter-wrapper-all">
          <div className="dash-filter-wrapper-all__fields">
            <div className="dash-filter-wrapper-all__fields--search">
              <label>Filter by Name</label>
              <input
                type="search"
                placeholder="Search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              ></input>
            </div>
            <div className="select-candidate__fields--select dash-filter-wrapper-all__fields--select">
              <div className="form-group">
                <label>Availability</label>
                <select
                  onChange={(e) => setStatusFilter(e.target.value)}
                  value={statusFilter}
                >
                  <option value="">All</option>
                  <option value="1">Pending</option>
                  <option value="2">Approved</option>
                  <option value="3">Deny</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="dash-jobs-cards dash-card-wrapper">
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div className="dash-cards-wrapper-inner dash-cards-wrapper-inner-companies">
                <div className="job-card card-dash-all card-dash-all-first">
                  <div className="job-card__name">
                    <p>Company</p>
                  </div>
                  <div className="job-card__company--website">
                    <p>Company Website</p>
                  </div>
                  <div className="job-card__email">
                    <p>Email</p>
                  </div>
                  <div className="job-card__jobs--number">
                    <p>Number of Jobs</p>
                  </div>
                  <div className="job-card__company--status">
                    <p>Status</p>
                  </div>
                </div>
                {companies.length > 0 ? (
                  companies.map((curr) => (
                    <div className="job-card card-dash-all" key={curr.id}>
                      <div className="job-card__name  dash-card__img--name">
                        <img
                          src={
                            curr.avatar === null
                              ? profileImgSrc
                              : `${base_url}${curr.avatar}`
                          }
                          alt="logo"
                        />
                        <div className="job-card__company-info">
                          <h4>{curr.name}</h4>
                        </div>
                      </div>
                      <div className="job-card__company--website">
                        <p>{curr.website}</p>
                      </div>
                      <div className="job-card__email">
                        <p>{curr.email}</p>
                      </div>
                      <div className="job-card__jobs--number">
                        <p>{curr.jobs_count}</p>
                      </div>
                      <div className="job-card__company--status job-card__company--status--flex">
                        <div className="select-custom-wrapper">
                          <button
                            onClick={() => handleOpen(curr.id)}
                            className={`${
                              isLoadingStatus ? "blink-disabled" : ""
                            }`}
                          >
                            <span
                              style={{
                                backgroundColor: statusOptions.find(
                                  (opt) => opt.value === String(curr.status)
                                )?.color,
                              }}
                            ></span>
                            {
                              statusOptions.find(
                                (opt) => opt.value === String(curr.status)
                              )?.label
                            }
                          </button>
                          <div
                            className={`${
                              isLoadingStatus ? "disabled" : ""
                            } select-custom-wrapper__options ${
                              openCompanyId === curr.id ? "active" : ""
                            }`}
                          >
                            {statusOptions.map((options, index) => (
                              <button
                                onClick={(e) =>
                                  handleStatus(options.value, curr.id)
                                }
                                key={index}
                              >
                                <span
                                  style={{ backgroundColor: options.color }}
                                ></span>
                                {options.label}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="job-card__edit--company--profile proffesional-edit-wrapper">
                          <Link to={`/admin/company-profile/${curr.id}/edit`}>
                            <svg
                              width="11"
                              height="11"
                              viewBox="0 0 11 11"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.85373 10.2944H9.2799M9.2799 1.44349C9.8712 2.03481 9.8712 2.99352 9.2799 3.58485L3.6431 9.22162C3.32184 9.54288 2.88611 9.72339 2.43177 9.72339H1.57103C1.25566 9.72339 1 9.46774 1 9.15236V8.29159C1 7.83728 1.18048 7.40153 1.50175 7.08027L7.13855 1.44349C7.72985 0.852169 8.6886 0.852169 9.2799 1.44349Z"
                                stroke="white"
                                strokeWidth="0.856542"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No Companies</p>
                )}
              </div>
              <div className="job-dashboard-pagination pagination-all">
                {Array.from(
                  { length: pagination.last_page },
                  (_, i) => i + 1
                ).map((num) => (
                  <button
                    key={num}
                    className={num === pagination.current_page ? "active" : ""}
                    onClick={() => setPage(num)}
                  >
                    {num}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
